import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from  './dashboard/dashboard.component';
import { InvestigacionIncidentesComponent } from './investigacion-incidentes/investigacion-incidentes.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'ssoma/dashboard', component: DashboardComponent },
      //{ path: 'ssoma/incidentes', component: InvestigacionIncidentesComponent  },
      { path: 'ssoma/incidentes/:idModulo', component: InvestigacionIncidentesComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SsomaRoutingModule { }
